<template>
	<v-card class="pa-5 full-width">
		<update-payment-details
			:isPaymentDetailsPresent="isPaymentDetailsPresent"
			:paymentDetails="paymentDetails"
			:userId="userId"
			:username="username"
			:retailerData="retailerData"
			:themeInputColor="themeInputColor"
		/>

		<withdraw-money
			:userId="userId"
			:themeInputColor="themeInputColor"
			:username="username"
			:walletDetails="walletDetails"
			:paymentDetails="paymentDetails"
			:isPaymentDetailsPresent="isPaymentDetailsPresent"
		/>

		<v-layout>
			<v-flex>
				<transaction-history :userId="userId" :themeInputColor="themeInputColor" />
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
import {
	ADD_UPDATE_PAYMENT_DETAILS,
	GET_PAYMENT_DETAILS,
	SEND_SMS
} from "@/store/action-types";

import { mapState } from "vuex";

import TransactionHistory from "@/components/TransactionHistory";
import WithdrawMoney from "./withdraw-money";
import UpdatePaymentDetails from "./update-payment-details";

import { themeInputColor } from "@/utils";

export default {
	name: "PaymentSection",
	data() {
		return {
			updatePaymentDialog: false,
			accNo: null,
			accIfsc: null,
			accName: null,
			accType: null,
			userState: null,
			status: null,
			updatePaymentDetailsLoading: false,
			getPaymentDetailsLoading: false,
			amountToSend: 0,
			themeInputColor,
			availableAmount: 0
		};
	},
	components: {
		"transaction-history": TransactionHistory,
		"withdraw-money": WithdrawMoney,
		"update-payment-details": UpdatePaymentDetails
	},
	mounted() {
		this.getPaymentDetails();
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID,
			username: state => state.auth.USERNAME,
			retailerData: state => state.retail.retailerData,
			paymentDetails: state => state.payment.paymentDetails
		}),
		isPaymentDetailsPresent() {
			return (
				this.paymentDetails &&
				Object.keys(this.paymentDetails).length > 0
			);
		},
		walletDetails() {
			const { walletDetails = {} } = this.retailerData;
			return walletDetails;
		}
	},
	methods: {
		getPaymentDetails() {
			if (!this.getPaymentDetailsLoading) {
				this.getPaymentDetailsLoading = true;
				this.$store
					.dispatch(GET_PAYMENT_DETAILS.dispatch)
					.catch(() => {})
					.then(() => {
						this.getPaymentDetailsLoading = false;
					});
			}
		},
		sendOTP() {
			const to_send = {
				username: this.username,
				amount: this.amountToSend
			};
			if (!this.sendOTPLoading) {
				this.sendOTPLoading = true;
				this.$store
					.dispatch(SEND_SMS.dispatch, to_send)
					.catch(() => {})
					.then(() => {
						this.sendOTPLoading = false;
						this.otpModal = true;
					});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
</style>

